import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import { 
  LayoutDashboard as DashboardIcon, 
  Briefcase as ProjectsIcon, 
  Users as TeamIcon, 
  Calendar as TimelineIcon,
  Settings as SettingsIcon,
  HelpCircle as HelpIcon,
  Info as InfoIcon
} from 'lucide-react';

const mainListItems = [
  { text: 'Dashboard', icon: <DashboardIcon size={20} />, view: 'dashboard' },
  { text: 'Projects', icon: <ProjectsIcon size={20} />, view: 'projects' },
  { text: 'Team', icon: <TeamIcon size={20} />, view: 'team' },
  { text: 'Timeline', icon: <TimelineIcon size={20} />, view: 'timeline' },
];

const secondaryListItems = [
  { text: 'Settings', icon: <SettingsIcon size={20} />, view: 'settings' },
  { text: 'About', icon: <InfoIcon size={20} />, view: 'about' },
  { text: 'Feedback', icon: <HelpIcon size={20} />, view: 'feedback' },
];

interface MenuContentProps {
  currentView: string;
  onViewChange: (view: string) => void;
}

export default function MenuContent({ currentView, onViewChange }: MenuContentProps) {
  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton 
              selected={currentView === item.view}
              onClick={() => onViewChange(item.view)}
              sx={{
                borderRadius: '8px',
                mb: 0.5,
                color: currentView === item.view ? '#ffffff' : '#aaaaaa',
                '& .MuiListItemIcon-root': {
                  color: currentView === item.view ? '#ffffff' : '#aaaaaa',
                },
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                },
                '&.Mui-selected': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  color: '#ffffff',
                  '& .MuiListItemIcon-root': {
                    color: '#ffffff',
                  },
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  },
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>
              <ListItemText 
                primary={item.text} 
                primaryTypographyProps={{ 
                  fontSize: '0.875rem', 
                  fontWeight: currentView === item.view ? 600 : 400 
                }} 
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              selected={currentView === item.view}
              onClick={() => onViewChange(item.view)}
              sx={{
                borderRadius: '8px',
                mb: 0.5,
                color: currentView === item.view ? '#ffffff' : '#aaaaaa',
                '& .MuiListItemIcon-root': {
                  color: currentView === item.view ? '#ffffff' : '#aaaaaa',
                },
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                },
                '&.Mui-selected': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  color: '#ffffff',
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} primaryTypographyProps={{ fontSize: '0.875rem' }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
